import { apiBusyState, componentApi } from '@/data'
import { ExtendedTragArmSystemInfo } from 'hcosmos-api-data'
import { Ref } from 'vue'
import { useToast } from 'vue-toastification'
import i18n from '@/locales/i18n'

const toast = useToast()
const { t } = i18n.global

function createFetchTragarms(ref: Ref<ExtendedTragArmSystemInfo[]>) {
  return async (revalidate: boolean = false) => {
    if (!revalidate && ref.value.length > 0) {
      return ref.value
    }
    try {
      apiBusyState.component = true
      const arms = await componentApi.listDetailedTragArms()
      ref.value = arms
      return arms
    } catch (error) {
      if (error instanceof Error) {
        console.error(error)
        toast.error(error.message)
      } else {
        console.error(error)
        toast.error(t('messages.toast.errorServer'))
      }
      return ref.value
    } finally {
      apiBusyState.component = false
    }
  }
}

export { createFetchTragarms }